module.exports = __webpack_public_path__ + "static/img/logo97.2df5b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo97.png
// module id = RD8t
// module chunks = 1